import React from "react";
import { pages } from "../../../../data/local";
import { PageType, SingularPage } from "../../../../types";
import { IconButton } from "./icon-button";
import clsx from "clsx";

interface Props {
  currentPage: SingularPage;
  onSelect: (val: PageType) => void;
  showMobile: boolean;
}

export function IconButtonBar({ currentPage, onSelect, showMobile }: Props) {
  return (
    <div
      className={clsx("mb-4 ", {
        "flex flex-row mb-12": !showMobile,
        "grid gap-2.5 ": showMobile,
      })}
    >
      {pages.map((p, i) => (
        <IconButton
          onClick={() => onSelect(p.type)}
          page={p}
          key={i}
          showMobile={showMobile}
          active={currentPage.type === p.type}
        />
      ))}
    </div>
  );
}
